import e from "./index212.mjs";
function r(t) {
  return e(1, arguments), t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
export {
  r as default
};
//# sourceMappingURL=index213.mjs.map
